import { GuestProfileService } from '../../guest-profile/guest-profile.service';
import { GuestProfile } from '../../guest-profile';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { UserTitles } from '@app/_helpers/constants';

@Component({
    selector: 'guest-profile',
    templateUrl: './guest-profile.component.html',
    styleUrls: ['./guest-profile.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class GuestProfileComponent implements OnInit {
	guestProfile: any;
	countries: any;
	states: any;
	titles: any;

	constructor(
		private constantService: ConstantService,
		private primengConfig: PrimeNGConfig,
		private guestProfileService: GuestProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.guestProfile = data.guestProfile,
			this.statuses = guestProfileService.statuses;
			this.countries = this.constantService.countries; 
			this.states = this.constantService.states;
			this.titles = UserTitles;
	}

	@Input() guestProfiles: GuestProfile;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	guestProfileId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'guestProfileId': [],
		'firstName': [
			{ type: 'required', message: 'Required' }
		],
		'lastName': [
			{ type: 'required', message: 'Required' }
		],
		middleName: [],
		suffix: [],
		title: [],
		emailAddress: [],
		mobilePhone: [],
		notes: [],
		primaryContact: [],
		adrStreet: [],
		adrStreet2: [],
		adrCity: [],
		adrState: [],
		adrPostalCode: [],
		adrCountry: [],
		adrPhone: [],
		adrFax: [],
		countryCode:[],
		emergencyContactName: [],
		emergencyContactPhone: [],
		emergencyContactNotes: [],
		travelOccasion: [],
		travelOccasionNotes: [],
		leadPurchaseOptIn: [],

	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole guestProfile object
		if (this.guestProfile) {
			this.guestProfileId = this.guestProfile.guestProfileId;
			this.fixDates();
			this.form1.patchValue(this.guestProfile);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.guestProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.guestProfileService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.guestProfile = res.data.guestProfile;
						this.doAdd.emit(this.guestProfile);
					},
					(err: any) => {
						console.log('guestProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('guestProfile: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.guestProfileService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.guestProfile = res.data.guestProfile;
						this.doUpdate.emit(this.guestProfile);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.guestProfileService.delete(this.guestProfile.guestProfileId)
				.subscribe(
					(res: any) => {
						console.log('guestProfile-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.guestProfile);
					},
					(err: any) => {
						console.log('guestProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			guestProfileId: [this.guestProfileId],
			firstName: ['', Validators.required],
	      	lastName: ['', Validators.required],
				middleName: [],
				suffix: [],
				title: [],
				emailAddress: [],
				mobilePhone: [],
				notes: [],
				primaryContact: [],
				adrStreet: [],
				adrStreet2: [],
				adrCity: [],
				adrState: [],
				adrPostalCode: [],
				adrCountry: [],
				adrPhone: [],
				adrFax: [],
				countryCode:[],
				emergencyContactName: [],
				emergencyContactPhone: [],
				emergencyContactNotes: [],
				travelOccasion: [],
				travelOccasionNotes: [],
				leadPurchaseOptIn: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.guestProfile.guestProfileDate = moment(this.guestProfile.guestProfileDate).toDate();
	}
}
